import React  from 'react';
import NextButton from '../../components/nextButton';
import styled, { keyframes } from 'styled-components';
import { bounce, bounceIn, zoomIn, pulse } from 'react-animations';

import './style.css';

const Word6 = styled.img`
animation: 2s ${keyframes`${zoomIn}`} ;
  max-width: 50%;
	@media screen and (max-width: 991px) {
  	width: 150px;
	}
	@media screen and (max-width: 767px) {
		width: 100px;
  }
	@media screen and (max-width: 479px) {
		width: 120px;
	}

`;

const Word1 = styled.img`
animation: 4s ${keyframes`${zoomIn}`} ;
	max-width: 50%;
	margin-left: 40px;
	@media screen and (max-width: 991px) {
  	width: 150px;
	}
	@media screen and (max-width: 767px) {
		width: 100px;
    margin-left: 20px;

  }
	@media screen and (max-width: 479px) {
    width: 120px;
    margin-left: 0px;

	}

`;

const Word5 = styled.img`
animation: 2s ${keyframes`${pulse}`} ;
	max-width: 50%;
	margin-left: 60px;
	@media screen and (max-width: 991px) {
		width: 150px;
	}
	@media screen and (max-width: 767px) {
		width: 100px;
    margin-left: 0px;

  }

`;
const Word2 = styled.img`
animation: 3s ${keyframes`${bounce}`} ;
	max-width: 50%;
	margin-left: 100px;
	@media screen and (max-width: 991px) {
  	width: 150px;
	}
	@media screen and (max-width: 767px) {
		width: 100px;
    margin-top: 0px;
    margin-left: 20px;

  }

`;

const Word4 = styled.img`
animation: 3s ${keyframes`${zoomIn}`} ;
	max-width: 50%;
	margin-top: 40px;
  margin-left: 140px;

	@media screen and (max-width: 991px) {
		margin-left: 40px;
	}
	@media screen and (max-width: 767px) {
		width: 100px;
    margin-left: 0px;

  }

`;
const Word3 = styled.img`
animation: 3s ${keyframes`${bounceIn}`} ;
  max-width: 50%;
	@media screen and (max-width: 991px) {
		width: 150px;
	}
	@media screen and (max-width: 767px) {
		width: 100px;
  }

	@media screen and (max-width: 479px) {
		width: 120px;
	}
 
`;


const PageWordsItog = ({ onNextLevel, messNext, answer, setAnswer }  ) => {
  return (
<>
<div className="section">
			<div className="container">
				<div className="head">собери слово</div>
				<div className="wrapper just_end">
					<div className="word-box">
						<div className="word-wrp"><Word6 src="images/word6.png" loading="lazy" alt="" className="image-17"/></div>
						<div className="word-wrp"><Word1 src="images/word1.png" loading="lazy" alt="" className="image-15"/></div>
						<div className="word-wrp"><Word5 src="images/word5.png" loading="lazy" alt="" className="image-16"/></div>
						<div className="word-wrp"><Word2 src="images/word2.png" loading="lazy" alt="" className="image-18"/></div>
						<div className="word-wrp"><Word4 src="images/word4.png" loading="lazy" alt="" className="image-19"/></div>
						<div className="word-wrp"><Word3 src="images/word3.png" loading="lazy" alt="" className="image-20"/></div>
					</div>
					<div className="bottom-box width">
						<div className="input-box">
							<div className="text-block">Впиши в поле слово собранное из первых букв</div>
              <input autoFocus ref={input => input && input.focus()} value={answer} onChange={(e)=>setAnswer(e.target.value)} className="input-q" />
						</div>
            <NextButton classes="button-q w-button" onNextLevel={onNextLevel} messNext="дальше" />            
            </div>
				</div>
			</div>
		</div>

    </>
  );
}

export default PageWordsItog;
